import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stumbleupon-circle': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 185.5c9.8 0 17.8 8 17.7 17.6v20.6l22.9 10.7 34.1-10.1v-23.7c0-40.3-34-72.6-74.7-72.6-40.5 0-74.7 32.1-74.7 72.1v108.4c0 9.9-8 17.8-17.8 17.8s-17.8-7.8-17.8-17.8v-45.8h-57.3v46.5c0 41.4 33.5 74.9 74.9 74.9 41 0 74.9-33 74.9-73.9v-106.9c0-9.8 8-17.8 17.8-17.8zM423.6 309.1c0 0 0-0.5 0.1-46.4h-57.3v48c0 9.7-8 17.6-17.8 17.6-9.8 0-17.8-7.8-17.8-17.6v-47.1l-34.1 10.1-22.9-10.7v46.8c0 41 33.7 74.2 74.9 74.2 41.4 0 74.9-33.5 74.9-74.9z'
      }
    ]
  }
})
